export const IS_ORDER = 'IS_ORDER';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/isOrder.js